import React from 'react';
import PermissionStateControls from '@/components/PermissionStateControls';

export const WORSHIP_PERMISSION_OPTIONS = [
  ['worship.view', 'Worship bekijken'],
  ['worship.view_all', 'Volledig overzicht bekijken'],
  ['worship.manage', 'Worship beheren'],
];

const WorshipPermissionControls = ({
  member,
  disabled = false,
  savingPermission = null,
  onChange,
}) => (
  <PermissionStateControls
    permissionOptions={WORSHIP_PERMISSION_OPTIONS}
    states={member?.worship_permission_states}
    disabled={disabled}
    savingPermission={savingPermission}
    onChange={onChange}
  />
);

export default WorshipPermissionControls;
